import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { Row,  Table } from 'reactstrap';

import { useNavigate, useLocation } from 'react-router-dom';
import { BiEditAlt, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import { BiLeftArrowAlt } from 'react-icons/bi';
import { axiosPrivate } from '../../api/useAxios';
import useAuth from '../../hooks/useAuth';


const SliderView = () => {
    const { auth } = useAuth();

    const [sliders, setSliders] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    const buildSliderImageUrl = (sliderImg) => {
        if (!sliderImg) {
            return '';
        }

        const apiImageUri = process.env.REACT_APP_API_IMAGE_URI || '';
        const apiIndex = apiImageUri.indexOf('/api');
        const imageBase = apiIndex > -1 ? apiImageUri.substring(0, apiIndex) : apiImageUri;
        const uploadIndex = sliderImg.indexOf('/uploads');
        const imagePath = uploadIndex > -1 ? sliderImg.substring(uploadIndex) : sliderImg;

        return `${imageBase}${imagePath}`;
    };

    // const {sliders} = useContext(ContactContext);
    const handleDelete =  async (event, id) => {
        event.preventDefault();
        try {
            const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/sliders/delete-slider/${id}`,  {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            });
            const res1 = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/sliders/find-all`);
            setSliders(res1.data);
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
        } catch (error) {
            error?.response?.data?.message ? toast.error(error.response.data.message, {
                className: "error-toast",
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
                }) :  toast.error(error?.response?.data?.error || 'Failed to delete slider', {
                  className: "error-toast",
                  position: toast.POSITION.BOTTOM_RIGHT,
                  autoClose: 3000
              })
         }
    }
        
   
//     useEffect(() => {
//       const source = axios.CancelToken.source();
//       const getsliders = async () => {
//       try {
//           const res = await axios.get(`http://localhost:9101/real-fm/api/v1/sliders/find-all`, {
//               cancelToken: source.token
//           });
//           setSliders(res.data);
         
//       } catch (error) {
//               if (axios.isCancel(error)) {
//                   console.log('cancelled');
//               } else {
//                   throw error;
//               }
//           }
//       }
      
//       getsliders();
//       return () => {
//           source.cancel();
//       };
//   },[])

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const getsliders = async () => {
            try {
                const response = await axiosPrivate.get(`${process.env.REACT_APP_API_BASE_URL}/sliders/find-all`, {
                    signal: controller.signal
                });
                isMounted && setSliders(response.data);
            } catch (error) {
                navigate('/login', { state: { from: location }, replace: true });

                // error.response.data.message ? toast.error(error.response.data.message, {
                //     className: "error-toast",
                //     position: toast.POSITION.BOTTOM_RIGHT,
                //     autoClose: 3000
                //     }) :  toast.error(error.response.data.error, {
                //       className: "error-toast",
                //       position: toast.POSITION.BOTTOM_RIGHT,
                //       autoClose: 3000
                // })
            }
        }

        getsliders();

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [])
    return (
        <div className="container">
          <Row sm="12">
            <h5 className="sec-header">Sliders List</h5>
        </Row> 
        <Row>
            <Table responsive hover>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Sequence</th>
                    <th>Image</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {
                    sliders.map(slider => (
                      <tr key={slider.id}>
                        {/* <sliderList slider={slider} /> */}
                            <td>{slider.id}</td>
                            <td style={{wordBreak: "break-all"}}>{slider.sliderTitle}</td>
                            <td style={{wordBreak: "break-all"}}>{slider.sliderDesc}</td>
                            <td>{slider.sliderSequence}</td>
                            <td><img style={{width: 120}} src={buildSliderImageUrl(slider.sliderImg)} alt={slider.sliderTitle}></img></td>
                            <td>
                                <BiEditAlt className="edit_icon icon_hover" onClick={() => navigate(`/sliders/edit/${slider.id}`)} size={20}/> 
                                <BiTrash className="delete_icon icon_hover" onClick={(event) => handleDelete(event, slider.id)} size={20} />
                                
                                
                            </td>
                    </tr>
                  ))  
                }
                                
                </tbody>
            </Table>
     </Row>
     {
        sliders && <Row sm="12" className="mt-4 text-center">
          <Link to={"/sliders/add"} className="go_back" >
            <BiLeftArrowAlt size={30} /> Go to Add slider
          </Link>
      </Row> 
         }
        </div>
    )
   
}

export default SliderView;